var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4747 9.7044C15.8659 8.99354 15.5893 8.3775 15.5893 7.33092V6.97507C15.5893 5.61124 15.2754 4.73251 14.593 3.85379C13.5411 2.48912 11.7704 1.66663 10.0369 1.66663H9.96323C8.26621 1.66663 6.55097 2.45135 5.48091 3.76063C4.76119 4.65698 4.41085 5.57347 4.41085 6.97507V7.33092C4.41085 8.3775 4.15245 8.99354 3.52549 9.7044C3.06417 10.2281 2.91675 10.9012 2.91675 11.6297C2.91675 12.359 3.1561 13.0498 3.63647 13.6113C4.26343 14.2844 5.1488 14.7141 6.05321 14.7888C7.36262 14.9382 8.67203 14.9944 10.0005 14.9944C11.3281 14.9944 12.6375 14.9004 13.9478 14.7888C14.8514 14.7141 15.7367 14.2844 16.3637 13.6113C16.8432 13.0498 17.0834 12.359 17.0834 11.6297C17.0834 10.9012 16.936 10.2281 16.4747 9.7044Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.674 16.0236C11.2574 15.9347 8.71888 15.9347 8.30229 16.0236C7.94616 16.1059 7.56104 16.2972 7.56104 16.7169C7.58174 17.1172 7.81613 17.4706 8.14079 17.6946L8.13996 17.6955C8.55987 18.0228 9.05266 18.2309 9.56864 18.3056C9.8436 18.3434 10.1235 18.3417 10.4084 18.3056C10.9236 18.2309 11.4164 18.0228 11.8363 17.6955L11.8355 17.6946C12.1601 17.4706 12.3945 17.1172 12.4152 16.7169C12.4152 16.2972 12.0301 16.1059 11.674 16.0236Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.981a117f8d178457b432d22c12e13127.svg";
export { ForwardRef as ReactComponent };